import React from 'react';
import styles from '../styles/Header.module.css';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <div className={styles.leftSection}>
          <div className={styles.logoContainer}>
            <Link to="/" className="logo">
              <span className="monteText">monte</span>
              <span className="x2Text">X2</span>
            </Link>
          </div>
          <nav className={styles.nav}>
            <Link to="/" className={styles.navLink}>
              Home
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
